/*
 * @Author: kuangxj 
 * @Email: frankxjkuang@gmail.com 
 * @Date: 2018-07-09 15:49:13 
 * @Last Modified by:   kaungxj 
 * @Last Modified time: 2018-07-09 15:49:13 
 * @Description: File desctiption 
 */

import MoorButton from './moor-button';

MoorButton.install = function(Vue) {
  Vue.component(MoorButton.name, MoorButton);
};

export default MoorButton;



// WEBPACK FOOTER //
// ./src/packages/button/index.js